/**
 * Default category destination — the marketing-city editorial page. The path
 * is host-relative, so on `<city>.loci.city` it resolves to
 * `<city>.loci.city/category/<slug>` (HTTP 200).
 *
 * NEVER prefix the city slug here. `/<city>/category/<slug>` 404s on *every*
 * surface: it matches no route on the city host (the city is the subdomain,
 * not a path segment) and no route on the app host (the app surface has no
 * category page). That broken shape was the root cause of the dead Categories
 * nav on both `app.loci.city` and `<city>.loci.city`.
 */
export function defaultCategoryHref(slug: string): string {
  return `/category/${slug}`;
}
